module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/feed-added-ab02403d413140c5b65f11a6c0190229.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/feed-added.svg
// module id = QhnS
// module chunks = 24